{
  "name": "@vercel/edge-config",
  "version": "1.4.3",
  "description": "Ultra-low latency data at the edge",
  "homepage": "https://vercel.com",
  "repository": {
    "type": "git",
    "url": "https://github.com/vercel/storage.git",
    "directory": "packages/edge-config"
  },
  "license": "Apache-2.0",
  "sideEffects": false,
  "type": "module",
  "exports": {
    ".": {
      "next-js": {
        "import": "./dist/index.next-js.js",
        "require": "./dist/index.next-js.cjs"
      },
      "import": "./dist/index.js",
      "require": "./dist/index.cjs"
    }
  },
  "main": "./dist/index.cjs",
  "module": "./dist/index.js",
  "files": [
    "dist"
  ],
  "scripts": {
    "build": "tsup",
    "dev": "tsup --watch --clean=false",
    "lint": "eslint --max-warnings=0 .",
    "prepublishOnly": "pnpm run build",
    "prettier-check": "prettier --check .",
    "publint": "npx publint",
    "test": "pnpm run test:node && pnpm run test:edge && pnpm run test:common",
    "test:common": "jest --env @edge-runtime/jest-environment .common.test.ts && jest --env node .common.test.ts",
    "test:edge": "jest --env @edge-runtime/jest-environment .edge.test.ts",
    "test:node": "jest --env node .node.test.ts",
    "type-check": "tsc --noEmit"
  },
  "jest": {
    "preset": "ts-jest",
    "setupFiles": [
      "<rootDir>/jest/setup.js"
    ],
    "testEnvironment": "node"
  },
  "dependencies": {
    "@vercel/edge-config-fs": "workspace:*"
  },
  "devDependencies": {
    "@changesets/cli": "2.28.1",
    "@edge-runtime/jest-environment": "2.3.10",
    "@edge-runtime/types": "2.2.9",
    "@types/jest": "29.5.14",
    "@types/node": "22.13.5",
    "eslint": "8.56.0",
    "eslint-config-custom": "workspace:*",
    "jest": "29.7.0",
    "jest-fetch-mock": "3.0.3",
    "next": "16.0.0-canary.15",
    "node-domexception": "2.0.1",
    "prettier": "3.5.2",
    "ts-jest": "29.2.6",
    "tsconfig": "workspace:*",
    "tsup": "8.4.0",
    "typescript": "5.7.3"
  },
  "peerDependencies": {
    "@opentelemetry/api": "^1.7.0",
    "next": ">=1"
  },
  "peerDependenciesMeta": {
    "@opentelemetry/api": {
      "optional": true
    },
    "next": {
      "optional": true
    }
  },
  "engines": {
    "node": ">=14.6"
  }
}
